module.exports = __webpack_public_path__ + "img/login.a212c9bd.png";